<template>
  <div class="pop">
    <p>请根据您的结算金额，按照要求为大救星开具增值税专用发票。 </br>发票内容：咨询费、推广费、服务费、综费或旅行服务费。 </p>
    <p class="red">*无法开具增值税专用发票的企业或个人，可选择使用普票进行结算，由此产生的税费系统自动扣去6%,即实际到账金额=提现金额+1.06。</p>
    <div class="radio">
        <el-radio v-model="radio" label="2">专票</el-radio>
        <el-radio v-model="radio" label="3">普票</el-radio>
    </div>
    <div class="overflow">
      <p>开票金额：<span class="yellow">￥{{listMoney/100}}元</span></p>
      <p>实际到账金额：<span class="yellow">￥{{(listMoney/100/lilv).toFixed(2)}}元</span></p>
    </div>
    <h3>大救星开票信息</h3>
    <ul class="ul">
      <li>1、公司名称：江泰救援服务有限公司</li>
      <li>2、税号：91120118MA05J5YJ07</li>
      <!-- <li>3、地址、电话：北京市门头沟区莲石湖西路98号院9栋2层201 010-68188889</li>
      <li>4、开户行：招商银行北京丽泽商务区支行 </li>
      <li>5、账号：110921622710301</li> -->
    </ul>
    <!-- <h3>方式一：寄送纸质发票</h3>
    <ul class="ul">
      <li>北京市门头沟区莲石湖西路98号院9号楼江泰大厦  大救星业务部收   010-69808888</li>
    </ul> -->
    <h3>方式二：上传电子发票</h3>
    <div>
					<el-upload class="upload-demo"
					action="aaa"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:limit="1"
					:on-exceed="handleExceed"
					:file-list="fileList"
					:before-upload="beforeAvatarUpload"
					:http-request="requestFile"
					 >
						<el-button size="small" type="primary" :loading="uploadBtn">点击上传</el-button>
						<!-- <div slot="tip" class="el-upload__tip">支持jpg、gif、bmp、png格式，最大不超过5M</div> -->
					</el-upload>
    </div>
    <el-button style="margin: 0 auto;display: block;margin-top: 20px;" type="primary" @click="appendInvoice()">提交电子发票</el-button>
  </div>
</template>

<script>
  import axios from 'axios'
	import { appendInvoice } from '@/axios/api'
  export default{
    data(){
      return{
        radio:'2',
        fileList: [],
        fileType: [ "pdf", "doc", "docx", "xls", "xlsx","txt","png","jpg", "bmp", "jpeg"],
        uploadBtn:false,
        fileUrl:[],
        lilv:'1.00'
      }
    },
    props:[
      'listId',
      'listMoney'
    ],
    methods: {
			//上传
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
        if (file.type != "" || file.type != null || file.type != undefined){
            //截取文件的后缀，判断文件类型
          const FileExt = file.name.replace(/.+\./, "").toLowerCase();
          //计算文件的大小
          const isLt5M = file.size / 1024 / 1024 < 50; //这里做文件大小限制
          //如果大于50M
          if (!isLt5M) {
            this.$showMessage('上传文件大小不能超过 5MB!');
            return false;
          }
          //如果文件类型不在允许上传的范围内
          if(this.fileType.includes(FileExt)){
            return true;
          }
          else {
            this.$message.error("上传文件格式不正确!");
            return false;
          }
        }
				// console.log(file);
        // var reg = /(.*)\.(jpg|gif|bmp|png)$/
        // if(!reg.test(file.name)){
        //   this.$message.error('上传仅支持jpg、gif、bmp、png格式');
        //   return false;
        // }
				// const isLt8M = file.size / 1024 / 1024 < 5;
				// if (!isLt8M) {
				// 	this.$message.error('上传头像图片大小不能超过 5MB!');
				// }
				// return isLt8M;
        
			},
      requestFile(param) {
      	this.uploadBtn=true;
      	var fileObj = param.file
      	let config = {
      		headers: {
      			"Content-Type": "multipart/form-data"
      		}
      	};
      	var form = new FormData() // FormData 对象
      	var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
      	form.append('file', fileObj) // 文件对象
      	form.append('token', token) // 文件对象
      	axios.post(SEVERS + 'rescue_sale/sale/upload', form, config)
      		.then(res => {
      			if (res.data.code == 0) {
      				this.fileUrl.push(res.data.obj);
      				this.uploadBtn=false
      			}
      		})
      		.catch(err => {
      			console.log(err)
      		})
      },
      appendInvoice(){
        if(this.fileUrl.length == 0) return this.$message.error('请先上传发票')
          var data={
            invoice:this.fileUrl[0],
            id:this.listId,
            invoiceType:this.radio
          }
          appendInvoice(data)
          .then(res => {
            console.log(res);
            if(res.data.code == 0){
              console.log(this.$parent);
              this.$parent.$parent.setState()
              this.$message.success('上传成功')
              this.fileUrl=[];
              this.fileList=[]
            }
          })
          .catch(err => {
            console.log(err);
          })
      }
    },
    watch:{
      radio(){
        if(this.radio == 2){
          this.lilv = 1
        }else{
          this.lilv= 1
          // this.lilv=1.06
        }
      }
    }
  }
</script>

<style scoped="scoped">
  .radio{padding: 30px 0;}
  .overflow{overflow: hidden;}
  .overflow >p{float: left;width: 300px;font-weight: 600;}
  h3{margin: 20px 0;}
  .ul li{font-size: 14px; line-height: 30px;color: #666;margin-left: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/fpPop.vue